import * as React from 'react'
import { ReactElement } from 'react'
import { tokens } from '@fluentui/react-theme'
import { makeStyles } from '@fluentui/react-components'
import AlertDialog from '../Dialog/AlertDialog'
import { bundleIcon, DeleteFilled, DeleteRegular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'

type Props = {
    disabled?: boolean
    className?: string
    buttonClassName?: string
    // Property to prevent the click event inside the dialog to reach elements outside the dialog which in turn cause the dialog to close.
    setPreventDefaultEvent?: (value: boolean) => void
    onConfirm?: (setOpen: (open: boolean) => void, setSubmitting: (submitting: boolean) => void) => void
}

const DeleteIcon = bundleIcon(DeleteFilled, DeleteRegular)

const useStyles = makeStyles({
    deleteButton: {
        backgroundColor: tokens.colorPaletteRedForeground3,
        '&:hover, &:active': {
            backgroundColor: `${tokens.colorPaletteRedForeground1} !important`,
        },
        '&:hover:active': {
            backgroundColor: `${tokens.colorPaletteRedForeground2} !important`,
        },
        height: tokens.lineHeightBase600,
    },
})

export default function DeleteBankTransactionButton(props: Props): ReactElement {
    const styles = useStyles()
    const { t: translate } = useTranslation()

    return (
        <AlertDialog
            className={props.className}
            onConfirm={props.onConfirm}
            title={translate('invoice.edit.form.banktransactions.remove.action')}
            content={translate('invoice.edit.form.banktransactions.remove.confirm')}
            triggerButtonProps={{
                className: props.buttonClassName,
                disabled: props.disabled,
                appearance: 'transparent',
                icon: <DeleteIcon />,
            }}
            confirmButtonProps={{
                icon: <DeleteIcon />,
                className: styles.deleteButton,
            }}
        />
    )
}
